module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-2@2-9fa65db76266fcccff6215cf848dca77.webp";